<div class="canvas-wrapper">
    <shared-signature-component [fileSignatureBytes]="fileSignatureBytes" [fileSignatureType]="fileSignatureType"
        [readonly]="readonly" (endDrawSignature)="onEndDrawSignature($event)"
        (clearSignature)="onClearSignature($event)">
    </shared-signature-component>
</div>

<div class="signedat" *ngIf="value?.signedAt">
    {{'SHARED.SIGNATURE.SIGNEDAT.CAPTION' | translate}}: {{value.signedAt | datehournosecondsnotzobserver}}
</div>

<div class="filainferior" *ngIf="!readonly && hasChanges">
    <button class="cancel" (click)="cancelSignature()">
        {{'GENERAL.CANCEL' | translate}}
    </button>
    <button class="add green" (click)="doSignature()">
        {{'GENERAL.SAVE' | translate}}
    </button>
</div>
